import { useEffect, useState, type ReactNode } from "react";
import { checkAdminSession } from "../lib/admin-auth";

/**
 * Route guard for admin-only SPA routes. On mount it asks /api/admin/me whether
 * the httpOnly admin_session cookie is valid. While loading: a spinner. If
 * authed: render children. If not: redirect to #/login?redirect=<here> (the
 * unified email+password login; PR #44).
 */
export default function RequireAdmin({ children }: { children: ReactNode }) {
  const [state, setState] = useState<"loading" | "ok" | "denied">("loading");

  useEffect(() => {
    let alive = true;
    checkAdminSession().then((ok) => {
      if (!alive) return;
      if (ok) {
        setState("ok");
      } else {
        setState("denied");
        const here = window.location.hash || "#/";
        window.location.hash = `#/login?redirect=${encodeURIComponent(here)}`;
      }
    });
    return () => {
      alive = false;
    };
  }, []);

  if (state === "ok") return <>{children}</>;
  return (
    <div className="flex items-center justify-center py-24 text-sm text-gray-500">
      <span className="inline-block h-4 w-4 mr-2 rounded-full border-2 border-gray-300 border-t-gray-600 animate-spin" />
      {state === "loading" ? "Checking access…" : "Redirecting to sign in…"}
    </div>
  );
}
